import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["icon"];

  connect() {
    // Theme is already set by the inline script, just update the icon
    const currentTheme = document.documentElement.getAttribute("data-bs-theme");
    this.updateIcon(currentTheme);
    this.updateMedievalText(currentTheme);
  }

  toggle() {
    const currentTheme = document.documentElement.getAttribute("data-bs-theme");
    // Cycle through themes: light -> dark -> medieval -> light
    let newTheme;

    if (currentTheme === "light") {
      newTheme = "dark";
    } else if (currentTheme === "dark") {
      newTheme = "medieval";
    } else {
      newTheme = "light";
    }

    // Update the theme
    document.documentElement.setAttribute("data-bs-theme", newTheme);

    // Save preference to localStorage
    localStorage.setItem("color-theme", newTheme);

    // Update the icon and text
    this.updateIcon(newTheme);
    this.updateMedievalText(newTheme);
  }

  updateIcon(theme) {
    if (!this.hasIconTarget) return;

    // Remove all existing classes first
    this.iconTarget.classList.remove(
      "bi-moon-fill",
      "bi-sun-fill",
      "bi-shield"
    );

    if (theme === "dark") {
      this.iconTarget.classList.add("bi-sun-fill");
    } else if (theme === "medieval") {
      this.iconTarget.classList.add("bi-shield");
    } else {
      this.iconTarget.classList.add("bi-moon-fill");
    }
  }

  // Handle medieval text replacements
  updateMedievalText(theme) {
    const medievalTextElements = document.querySelectorAll(
      "[data-medieval-text]"
    );

    medievalTextElements.forEach((element) => {
      const originalText =
        element.getAttribute("data-original-text") ||
        element.textContent.trim();

      // Store original text if not already stored
      if (!element.getAttribute("data-original-text")) {
        element.setAttribute("data-original-text", originalText);
      }

      // Replace with medieval text or restore original based on theme
      if (theme === "medieval") {
        element.textContent = element.getAttribute("data-medieval-text");
      } else {
        element.textContent = element.getAttribute("data-original-text");
      }
    });

    // Handle form labels and headings
    if (theme === "medieval") {
      // Replace common form text with medieval equivalents
      this.updateFormLabels();
    } else {
      // Reset form labels back to original when not in medieval mode
      this.resetFormLabels();
    }
  }

  updateFormLabels() {
    // Map of common labels to medieval equivalents
    const labelMap = {
      "Date and Time": "Time of Quest",
      "Notes": "Chronicles",
      "Log New Workout": "Inscribe New Quest",
      "Start Workout": "Embark on Quest",
      "Optional notes about your workout": "Record thy noble deeds...",
    };

    // Update heading elements
    document
      .querySelectorAll("h1, h2, h3, label, button, .form-control::placeholder")
      .forEach((el) => {
        const text = el.textContent.trim();
        if (labelMap[text]) {
          // Store original if not already stored
          if (!el.getAttribute("data-original-text")) {
            el.setAttribute("data-original-text", text);
          }
          el.textContent = labelMap[text];
        }
      });

    // Update placeholders
    document.querySelectorAll(".form-control").forEach((el) => {
      const placeholder = el.getAttribute("placeholder");
      if (placeholder && labelMap[placeholder]) {
        if (!el.getAttribute("data-original-placeholder")) {
          el.setAttribute("data-original-placeholder", placeholder);
        }
        el.setAttribute("placeholder", labelMap[placeholder]);
      }
    });
  }

  resetFormLabels() {
    // Reset elements with data-original-text
    document.querySelectorAll("[data-original-text]").forEach((el) => {
      if (!el.hasAttribute("data-medieval-text")) {
        // Skip elements that are handled by the primary mechanism
        el.textContent = el.getAttribute("data-original-text");
      }
    });

    // Reset placeholders
    document.querySelectorAll("[data-original-placeholder]").forEach((el) => {
      el.setAttribute(
        "placeholder",
        el.getAttribute("data-original-placeholder")
      );
    });
  }
}
